import { ChoiceBeat } from "./ChoiceBeat";
import { MultiBeat } from "./MultiBeat";
import { NumberBeat } from "./NumberBeat";
import { OrderBeat } from "./OrderBeat";
import { AssembleBeat } from "./AssembleBeat";
import { ConvChoiceBeat, ConvMultiBeat } from "./ConvBeats";
import { CprBeat } from "./CprBeat";
import { CrashTrolleyBeat } from "./CrashTrolleyBeat";
import { SterileFieldBeat } from "./SterileFieldBeat";
import { InstrumentTrayBeat } from "./InstrumentTrayBeat";
import { AutoclaveBeat } from "./AutoclaveBeat";
import { ExposureBeat } from "./ExposureBeat";
import { AlaraBeat } from "./AlaraBeat";
import { PositioningBeat } from "./PositioningBeat";
import { CountTrayBeat } from "./CountTrayBeat";
import { FloorPlanBeat } from "./FloorPlanBeat";

export { TensionMeter } from "./Shared";

const CUSTOM = {
  order: OrderBeat,
  assemble: AssembleBeat,
  cpr: CprBeat,
  crashtrolley: CrashTrolleyBeat,
  sterilefield: SterileFieldBeat,
  instruments: InstrumentTrayBeat,
  autoclave: AutoclaveBeat,
  exposure: ExposureBeat,
  alara: AlaraBeat,
  positioning: PositioningBeat,
  counttray: CountTrayBeat,
  floorplan: FloorPlanBeat,
};

export const renderBeat = (beat, props) => {
  const Custom = CUSTOM[beat.type];
  if (Custom) return <Custom key={props.beatKey} beat={beat} {...props} />;
  if (props.conversation && beat.type === "multi") return <ConvMultiBeat key={props.beatKey} beat={beat} {...props} />;
  if (props.conversation && beat.type === "choice") return <ConvChoiceBeat key={props.beatKey} beat={beat} {...props} />;
  if (beat.type === "multi") return <MultiBeat key={props.beatKey} beat={beat} {...props} />;
  if (beat.type === "number") return <NumberBeat key={props.beatKey} beat={beat} {...props} />;
  return <ChoiceBeat key={props.beatKey} beat={beat} {...props} />;
};
